import prettier from 'prettier/standalone';
import parserHtml from 'prettier/parser-html';
// import { html as beautifyHtml } from 'js-beautify';

export const get = (obj, path, defaultValue = '[TŁUMACZENIE]') =>
{
    if(!path) {
        return obj || defaultValue;
    }

    // const sections = path.replace(/\[/g, '').replace(/\]/g, '').split('.');
    const sections = path.replaceAll('[', '').replaceAll(']', '').split('.');

    let returnValue = obj;
    for (let i = 0; i < sections.length; i++)
    {
        const section = sections[i];

        if (returnValue && returnValue[section])
        {
            returnValue = returnValue[section];
        }
        else
        {
            returnValue = null;
            break;
        }
    }

    return returnValue ? returnValue: defaultValue;
};

/**
 * @template K
 * @template V
 * @param {Map<K, V>} map
 * @param {K} key
 * @param {() => V} defaultValue
 * @returns {V}
 */
export function ensureMapEntry(map, key, defaultValue)
{
    let value = map.get(key);
    if (!value)
    {
        value = defaultValue();
        map.set(key, value);
    }
    return value;
}

/**
 * @param {*} value
 */
export function getCharAtZero(value)
{
    if (!value || typeof value !== 'string') { return ''; }
    if (value.length === 0) { return ''; }
    return value.charAt(0);
}

/**
 * @template K
 * @template V
 * @param {Map<K, V>} map
 * @param {(value: V) => V} valueClone
 * @returns {Map<K, V>}
 */
export function cloneMap(map, valueClone)
{
    return new Map([...map.entries()].map(([key, value]) => [key, valueClone(value)]));
}

/**
 * @param {string?} a
 * @param {string?} b
 */
export function compareStrings(a, b)
{
    if (!a && !b) { return 0; }
    if (!a) { return -1; }
    if (!b) { return 1; }
    return a.localeCompare(b);
}

/**
 * @param {LocalizedValue[]?} a
 * @param {LocalizedValue[]?} b
 */
export function compareLocalizedValues(a, b)
{
    const aExists = a && a.length > 0;
    const bExists = b && b.length > 0;
    if (!aExists && !bExists) { return 0; }
    if (!aExists) { return -1; }
    if (!bExists) { return 1; }
    // const aName = a?.find(v => v.isDefault)?.name ?? a?.[0]?.name ?? '';
    // const bName = b?.find(v => v.isDefault)?.name ?? b?.[0]?.name ?? '';
    // return compareStrings(aName, bName);
    const aName = a?.[0]?.value ?? '';
    const bName = b?.[0]?.value ?? '';
    return compareStrings(aName, bName);
}

/**
 * @param {any} mods
 * @returns {Object}
 */
export function toPlainNested(mods)
{
    if (!mods) { return {}; }
    if (mods instanceof Map)
    {
        /** @type {any} */
        const outer = {};
        for (const [k, v] of mods.entries())
        {
            outer[k] = v instanceof Map ? Object.fromEntries(v) : v;
        }
        return outer;
    }
    return mods;
}

/**
 * @param {any} translations
 * @return {(key: string) => string}
 */
export function getT(translations)
{
    return key => translations?.[key] || key;
}

/**
 * @param {string} html
 * @returns
 */
export function prettyHtml(html)
{
    try
    {
        return prettier.format(html, {
            parser: 'html',
            plugins: [parserHtml],

            jsxBracketSameLine: true,
            bracketSameLine: true,
            singleAttributePerLine: false,
            htmlWhitespaceSensitivity: 'ignore',
            proseWrap: 'preserve',

            printWidth: 120,
            tabWidth: 2,
        });
    }
    catch { return html; }
    // try
    // {
    //     return beautifyHtml(html,
    //     {
    //         indent_size: 2,
    //         end_with_newline: true,

    //         wrap_line_length: 120,
    //         wrap_attributes: 'auto',
    //         wrap_attributes_min_attrs: 2,

    //         preserve_newlines: true,
    //         max_preserve_newlines: 2,
    //         extra_liners: [],
    //         unformatted: ['pre', 'code', 'textarea', 'script'],
    //         content_unformatted: ['pre', 'code', 'textarea'],
    //     });
    // }
    // catch { return html; }
}